import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { Checkbox } from "flowbite-react";
import { twMerge } from "tailwind-merge";


const ProductFilter = ({ label, options, selected, setSelected }) => {
  const [open, setOpen] = useState(true);
  const [openAllOptions, setOpenAllOptions] = useState(false);

  // Check if there are any options available (not invisible and with a name)
  const checkOptionsAreAvailable = options?.some((option) => option && option?.name && !option?.invisible);
  if (!options || options.length < 1 || !checkOptionsAreAvailable) return null;

  // Count total options that are not invisible and have a name
  const totalOptions = options.filter((option) => option && option?.name && !option?.invisible).length;

  // Check if a option in the options array is active (in the selected array)
  const isAnyOptionActive = options?.some((option) => option && option?.name && selected.includes(option?.name));

  // Filter options to only include those that are not invisible and have a name
  const filterOptions = options?.filter((option) => option && option?.name && !option?.invisible);

  useEffect(() => {
    if (isAnyOptionActive) {
      setOpenAllOptions(true);
    }
  }, [isAnyOptionActive])

  return (
    <div className={`px-6 pt-4 mb-4 duration-300 rounded-10 bg-light_grey`}>
      <button
        type="button"
        className="flex items-center justify-between w-full pb-4 bg-light_grey"
        onClick={() => {
          setOpen(!open);
          setOpenAllOptions(false)
        }}
      >
        <span className="text-base font-bold text-dark-text">{label}</span>
        <FontAwesomeIcon
          icon={faChevronRight}
          className={`ml-2 text-sm text-dark-text transition-transform ${open ? "rotate-90" : ""}`}
        />
      </button>
      <div className={twMerge("grid transition-[grid-template-rows] duration-300 grid-rows-[0fr] overflow-hidden", open && "grid-rows-[1fr] pb-4")}>
        <div className={`min-h-0 flex flex-col gap-3 transition-all duration-300 pl-[0.1875rem] ${open ? "opacity-100 pt-[0.1875rem]" : "opacity-0"}`}>
          {filterOptions?.map((option, idx) => {
            // const hide = idx >= 8 && !openAllOptions;
            // if (hide) return null;

            return (
              <label
                key={idx}
                className={`flex items-center gap-2 cursor-pointer ${option?.disabled ? " opacity-50" : ""}`}
              >
                <Checkbox
                  color="dark"
                  checked={selected.includes(option?.name)}
                  disabled={option?.disabled}
                  onChange={() => {
                    if (option?.disabled) return;
                    if (selected.includes(option?.name)) {
                      setSelected(selected.filter((v) => v !== option?.name));
                    } else {
                      setSelected([...selected, option?.name]);
                    }
                  }}
                />
                <span className="text-sm text-dark-text">{option?.name}</span>
              </label>
            )
          })}
          {/* {totalOptions > 8 && (
            <button
              onClick={() => setOpenAllOptions(!openAllOptions)}
              className="flex items-center gap-2 pt-1 text-sm cursor-pointer text-dark-text"
            >
              <span className="underline">{openAllOptions ? "Toon minder" : "Toon alles"}</span>
              <FontAwesomeIcon
                icon={faChevronRight}
                className={`w-auto !h-2.5 mt-0.5 transition-all duration-300 ${openAllOptions && "rotate-90"}`}
              />
            </button>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default ProductFilter;